
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import Loading from 'vux/src/components/loading/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Box from 'vux/src/components/box/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import cookie from 'vux/src/tools/cookie/index.js'


export default {
data () {
return {
play: false,
loaded: false
}
},
components: {
Swiper,
SwiperItem,
Loading,
Group,
Cell,
ViewBox,
XHeader,
XButton,
Box,
XInput,
PopupRadio,
Popup,
Radio,
cookie
},
mounted () {
this.loaded = true
this.play = true
window.scrollTo(0, 0)
},
methods: {}
}



// WEBPACK FOOTER //
// ./src/components/Usdt4.vue